import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "spinner-border tw-animate-spin tw-rounded-full tw-text-notify-medium",
        style: _normalizeStyle(_ctx.style)
    }, null, 4));
}
